export const theme = {
  color: {
    main: {
      white: "#ffffff",
      black: "#000000",
      wineRed: "#b8001f",
      roseRed: "#e83946",
      dimGrey: "#f5f6fa",
      darkGrey: "#252422",
      borderWineRed: "#e83946",
    },
    secondary: {
      grey: "#bfbfbf",
      rightsGrey: "#6c757d",
      productsBorderGrey: "#c0c0c0",
      lightGrey: "#e8e8e8",
      darkRed: "#9f5f5f",
      lightPink: "#fcd2e3",
      green: "#32a852",
      blue: "#405ac2",
      yellow: "#e0eb2f",
    },
  },
  spacing: {
    extraSmall: "0.25rem",
    small: "0.5rem",
    mediumSmall: "0.75rem",
    medium: "1rem",
    large: "1.5rem",
    larger: "1.75rem",
    extraLarge: "2rem",
    superLarge: "4rem",
  },
  breakpoints: {
    mobile: "600px",
    tablet: "1000px",
    desktop: "1300px",
  },
  fontSize: {
    small: "0.5rem",
    mediumSmall: "0.85rem",
    medium: "1rem",
    mediumLarger: "1.25rem",
    mediumLarge: "1.5rem",
    large: "2rem",
    subtitle: "3rem",
    subtitleLarge: "3.5rem",
    title: "4rem",
  },
  fontFamily: {
    main: `"Quicksand", sans-serif`,
    secondary: `"Dancing Script", cursive`,
  },
};
